import React, { Component } from "react";
import { RegistrationApi, TabuUtils } from "@10x/tabu-mobile-api";
import Strings from "@my-dld/assets/strings";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import Popup from "@my-dld/components/Popup/Popup";
import { useSelector } from "react-redux";
import { IStore } from "@my-dld/reducers/store";
import { dispatch } from "@my-dld/utils/StoreUtils";
import Action from "@my-dld/actions";

interface Props {
	id: string;
	onEidaStarted: ( maskedNumber: string ) => void;
	showRecoverPopup?: boolean;
	onDismiss?: () => void;
}

interface State {
	isLoading: boolean;
	error?: string;
	enable: boolean;
}

class EidaUpdate extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: false,
			enable: true,
		};
	}

	onOtherTask = ( started: boolean ) => {
		if ( started ) {
			this.setState( { error: undefined, enable: false } );
		} else {
			this.setState( { error: undefined, enable: true } );
		}
	};

	render() {
		const { isLoading, error, enable } = this.state;
		if ( this.props.showRecoverPopup ) {
			return <EIDAPopup
				onDismiss={ this.props.onDismiss }
				enable={ enable } isLoading={ isLoading } onUpdate={ this.initEIDAUpdate }
				error={ error }/>;
		} else
			return <EidaButton
				enable={ enable } isLoading={ isLoading } onUpdate={ this.initEIDAUpdate }
				error={ error }/>;
	}

	initEIDAUpdate = () => {
		if ( this.state.isLoading ) return;
		const id = this.props.id;
		trackEventWithData( "Login", "TryEidaUpdate", { id: id } );
		this.setState( { isLoading: true, error: undefined } );
		RegistrationApi.initEIDAUpdate( id )
		.then( x => TabuUtils.validateResponse( x, "ValidationErrors" ) )
		.then( ( r ) => {
			this.setState( { isLoading: false } );
			trackEventWithData( "Login", "TryEidaUpdateSuccess", { id: id } );
			this.props.onEidaStarted( r.MaskedMobile! );
		} ).catch( e => {
			trackEventWithData( "Login", "TryEidaUpdateSuccessError", { id: id, e: e + "" } );
			this.setState( { isLoading: false, error: e + "" } );
		} );

	};
}

type EIDAViewProps = {
	enable: boolean;
	onUpdate: () => void;
	onDismiss?: () => void;
	isLoading: boolean, error?: string
};

function EidaButton( props: EIDAViewProps ) {
	const { enable, onUpdate, isLoading, error } = props;
	return <>
		<div className="form-group text-center">
			<button
				disabled={ !enable }
				className="btn btn-link font-size14"
				type="submit" onClick={ onUpdate }>
				{ isLoading ? <div className="relative spinner-border " role="status">
					<span className="sr-only">Loading...</span>
				</div> : Strings.wrong_mobile_update_eida }
			</button>
		</div>
		{ error && <div className={ "alert alert-danger alert-danger-mydld invalid-feedback-otp" }>
			{ error }
		</div> }
	</>;
}

function EIDAPopup( props: EIDAViewProps ) {
	const { onUpdate, isLoading, error, onDismiss } = props;
	const close = () => {
		Popup.Dismiss( "eidarecover" );
	};
	return (
		<Popup
			id={ "eidarecover" } showCloseButton={ true } onDismiss={ onDismiss } showIcon={ false }
			clickOutsideToDismiss={ false } autoOpenMount={ true } modalBodyContainer={ "" }>
			<div className="modal-body modal-body-mydld">
				<div className="cancel-icon">
					<i className="fa fa-times"></i>
				</div>
				<div className="text-center"><strong>{ Strings.error_no_mobile }</strong></div>
				<p className="mt-2 text-center passCode-msg">
					{ Strings.error_no_mobile_desc }</p>
				<div className="alert alert-light-grey d-block mb-0">
					<strong>{ Strings.next_step }: </strong> { Strings.eida_update_nxt_step }</div>
				{ error && <div className={ "alert alert-danger alert-danger-mydld mb-0 mt-3" }>
					{ error }
				</div> }
			</div>
			<div className="modal-footer d-flex justify-content-between">
				<button
					className="btn btn-grey"
					type="submit" onClick={ close }>
					{ Strings.close }
				</button>
				<button
					className="btn btn_1"
					type="submit" onClick={ onUpdate }>
					{ isLoading ? <div className="relative spinner-border " role="status">
						<span className="sr-only">Loading...</span>
					</div> : Strings.update }
				</button>
			</div>
		</Popup>
	);
}

export default EidaUpdate;

export function ProfileUpdatedPopup() {
	const close = () => {
		Popup.Dismiss( "profileupdated" );
	};
	const onDismiss = () => {
		dispatch( Action.SHOW_PROFILE_UPDATED, false );
	};
	let showPopup = useSelector( ( state: IStore ) => {
		return state.User.showProfileUpdated;
	} );
	if ( !showPopup ) return null;
	return (
		<Popup
			id={ "profileupdated" } showCloseButton={ true } showIcon={ false } onDismiss={ onDismiss }
			clickOutsideToDismiss={ false } autoOpenMount={ true } modalBodyContainer={ "" }>
			<div className="modal-body modal-body-mydld">
				<div className="check-icon">
					<i className="fa fa-check"></i>
				</div>
				<div className="text-center"><strong>{ Strings.update_profile }</strong></div>
				<p className="mt-2 text-center passCode-msg">
					{ Strings.profile_update_success }</p>
			</div>
			<div className="modal-footer justify-content-center">
				<button
					className="btn btn_1"
					type="submit" onClick={ close }>
					{ Strings.dash_board }
				</button>

			</div>
		</Popup>
	);
}
